<template>
  <CommonPanel title="商家大学" :ifShowMore="collegeList.length > 0" moreTarget="_blank" moreLink="//school.haiziwang.com/">
    <div class="college">
      <template v-for="(cVal) in collegeList">
        <div class="college-item" :key="cVal.id" @click="goTrainingDetail(cVal.id)">
          <div class="college-item-main">
            <img :src="cVal.courseCoverUrl" alt="">
            <div class="content">
              <span class="name" v-line-clamp="1">{{cVal.courseName}}</span>
              <span class="keyword" v-line-clamp="1">{{cVal.courseKeywords}}</span>
            </div>
          </div>
          <div class="college-item-extra">
            <span>内容作者：{{cVal.source | sourceFormat}}</span>
            <span>发表时间：{{cVal.createTime | dataFormat}}</span>
          </div>
        </div>
      </template>
      <div v-if="collegeList.length === 0" class="empty-container">
        <a-empty />
      </div>
    </div>
  </CommonPanel>
</template>
<script>
  import CommonPanel from "@/components/common-panel/index"
  import { Empty } from 'ant-design-vue'
  import moment from 'moment'
  import _ from 'lodash'
  export default {
    name: 'biz-school',
    components: {
      CommonPanel,
      [Empty.name]: Empty
    },
    data() {
      return {
        collegeList: [],
      }
    },
    created() {
      this.queryCourseList()
    },
    methods: {
      // 查询课程列表
      async queryCourseList() {
        const buzzType = this.$cookie.get("buzzType") || ''
        let params = {
          page: 1,
          limit: 5,
          'pojo.bizType': 1, // 业务类型 商家大学 1
          'pojo.directedBusinessType': +buzzType, // 商家类型
          sign: 'c8556754260e4a5f9131b886697fa460'
        }
        let collegeRes = await this.$store.dispatch('queryCourseList', params)
        this.collegeList = _.get(collegeRes, ['data'])
      },
      // 跳转详情
      goTrainingDetail (id) {
        if (!id) return
        window.open(`//school.haiziwang.com/detail?id=${id}`)
      }
    },
    filters: {
      dataFormat(time) {
        return moment(time).format('YYYY-MM-DD: HH:mm:ss')
      },
      sourceFormat(v) {
        return v === 1 ? '商家' : '孩子王'
      }
    }
  }
</script>
<style lang="scss" scoped>
  .college {
    display: flex;
    flex-direction: column;
    height: 410px;
    .college-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      margin-bottom: 12px;
      cursor: pointer;
      border-bottom: 1px solid #f6f6f6;
      &:last-child {
        margin-bottom: 0;
      }
      .college-item-main {
        display: flex;
        img {
          width: 80px;
          height: 60px;
          flex-shrink: 0;
          margin-right: 10px;
        }
        .content {
          display: flex;
          flex-direction: column;
          .name {
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            margin-bottom: 10px;
          }
          .keyword {
            font-family: MicrosoftYaHei;
            font-size: 13px;
            color: #666666;
            letter-spacing: 0;
          }
        }
      }
      .college-item-extra {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        margin-left: 40px;
        span {
          line-height: 26px;
        }
      }
      @media screen and (max-width:1500px){
        .college-item-extra {
          display: none;
        }
      }
    }
    .empty-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
    }

  }
</style>
